import React from "react";
import * as styles from "./RadioTab.module.scss";
import classNames from "classnames";
import RadioHelper from "@app/components/RadioHelper";
import PropTypes from "prop-types";

const RadioTab = (props) => {
	return (
		<RadioHelper {...props}>
			{(inputProps) => {
				const className = classNames({
					[styles["radio-tab"]]: true,
					[styles["is-active"]]: inputProps.isActive,
					[props.className]: !!props.classNames,
				});
				return (
					<label htmlFor={props.id} className={className}>
						<div className={styles["content"]}>{props.label}</div>
					</label>
				);
			}}
		</RadioHelper>
	);
};

RadioTab.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	id: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
};

export default RadioTab;
